export enum PersonaPanelStep {
    SELECT_PERSONA = 'select-persona',
    TRIAL_UNLOCKED = 'trial-unlocked',
    SELECT_TRIAL_PLAN = 'select-trial-panel'
}

export enum Persona {
    BUSINESS_OWNER = '1-business-owner',
    DESIGN_PROFESSIONAL = '2-design-professional',
    MARKETING_PROFESSIONAL = '3-marketing-professional',
    MEMBER_RELIGIOUS_ORGANIZATION = '4-member-religious-organization',
    MEMBER_COMMUNITY_ORGANIZATION = '5-member-community-organization',
    TEACHER_STUDENT = '6-teacher-student',
    CONSUMERS = '7-consumers',
    OTHER = '8-other'
}

export function getPanelContainerClassName(isMobile: boolean): string {
    return `_full-height flex-column-justify-between ${isMobile ? 'spacing-p-t-2 spacing-p-b-4 spacing-p-l-4 spacing-p-r-4' : 'spacing-p-t-8 spacing-p-b-8 spacing-p-l-10 spacing-p-r-10'}`;
}